import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";
import { User } from "../../models/user.model";
import { UserDataProvider } from "../../data-provider/user.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";

let BillingContacts = {
    selector: "vcBillingContacts",
    templateUrl:
        "/angular/components/profile/campaign-info-billing-users.component.html",
    bindings: {},
    controller: class BillingContactsController {
        public currentUser: User;
        public activeCampaign: Campaign;
        public users: User[];

        private dialog: DialogUtils;
        private toast: ToastUtils;

        private userDataProvider: UserDataProvider;

        constructor(
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            UserDataProvider: UserDataProvider,
            CampaignDataProvider: CampaignDataProvider
        ) {
            this.dialog = DialogUtils;
            this.toast = ToastUtils;

            this.userDataProvider = UserDataProvider;

            this.currentUser = this.userDataProvider.getActiveUser();
            this.activeCampaign = CampaignDataProvider.activeCampaign;
            this.userDataProvider
                .getAllUsers()
                .then((users: User[]) => (this.users = users));
        }

        changeBilling(user: User, billing: boolean): void {
            this.userDataProvider.billing([user.uid], billing).then(
                () => {
                    user.billing = user.billing == "1" ? "0" : "1";
                    this.toast.success(
                        `Billing admin ${billing ? "assigned" : "removed"}`
                    );
                },
                () => this.toast.error()
            );
        }
        close(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("profile", ["campaign"])
    .component(BillingContacts.selector, BillingContacts);
